import { render } from "./AuthRegWindow.vue?vue&type=template&id=b5328796"
import script from "./AuthRegWindow.vue?vue&type=script&lang=js"
export * from "./AuthRegWindow.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__